export default () => undefined;



// WEBPACK FOOTER //
// ./app/javascript/utils/noop.js